import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

const TestRadio2 = ({ parentCallback }) => {
  const [age, setAge] = React.useState();

  const handleChange = (event) => {
    if (event.target.checked == true) {
      setAge(event.target.value);
    }
    // setAge(event.target.value);
  };

  // console.log(age);

  const sendData = () => {
    parentCallback(age);
  };

  React.useEffect(() => {
    sendData();
  }, [handleChange]);

  return (
    <>
      <div style={{ display: "flex" }}>
        <FormControl value={age} onChange={handleChange}>
          <RadioGroup
            value={age}
            row
            defaultValue={1}
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
          >
            <FormControlLabel
              value={1}
              control={<Radio />}
              label="Own Numbers
              "
              className="m-0"
            />
          
            <FormControlLabel
              value={3}
              control={<Radio />}
              label="All  Numbers"
              className="m-0 ms-1"
            />
          </RadioGroup>
        </FormControl>
      </div>
    </>
  );
};

export default TestRadio2;
